import React from 'react';
import styled from '@emotion/styled';
import { Box, BoxProps } from '@chakra-ui/react';
import { ThemeColors } from '@theme/foundations/colors';

interface CardProp {
  bgColor?: string;
}

const StyledCard = styled(Box)<CardProp>`
    position: relative;
    background-color: ${(props) => props.bgColor};
    width: 100%;
    border-radius: 16px;
    display:flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0px 4px 64px rgba(119, 130, 149, 0.1);
    border: 1px solid ${ThemeColors.neutral[300]};
`;

const Card = ({
  padding = '24px',
  children,
  bgColor = 'white',
  ...props
}: BoxProps & { padding?: '0' | '16px' | '24px' } & { bgColor?: string }) => {
  return (
    <StyledCard {...props} p={padding} bgColor={bgColor}>
      {children}
    </StyledCard>
  );
};

export default Card;
